export const SET_CURRENT_USER = 'containers/App/SET_CURRENT_USER';
export const UNSET_CURRENT_USER = 'containers/App/UNSET_CURRENT_USER';
export const SET_CURRENT_ME = 'containers/App/SET_CURRENT_ME';
export const UNSET_CURRENT_ME = 'containers/App/UNSET_CURRENT_ME';
